<template>
    <hts-form-select
        ref="selectInput"
        v-model="cValue"
        v-model:text="cText"
        :query="findVehicle"
        :filterable="true"
        :clearable="true"
        :use-strict="false"
        :label="$t('labels.vehicle')"
        :required="required"
        :multiple="multiple"
        :prop="prop"
        key-id="_id"
        key-label="licensePlate"
        @change="handleChange" />
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: [Array, String],
    default: () => ''
  },
  prop: String,
  cooperatorId: String,
  cooperatorRequired: Boolean,
  multiple: Boolean,
  required: Boolean,
  name: String
})

const emits = defineEmits(['update:modelValue', 'update:name', 'click'])

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const { modelValue, name, required, multiple, cooperatorId, cooperatorRequired } = toRefs(props)
const selectInput = ref<any>(null)
const handleClear = () => {
  selectInput.value?.clear()
}
watch(
  () => cooperatorRequired?.value,
  () => {
    selectInput.value?.clear()
  }
)
watch(
  () => cooperatorId?.value,
  () => {
    selectInput.value?.clear()
  }
)
const findVehicle = async (s: string) => {
  const api = $url.vehicle.vehicle.select

  const query: any = { key: s }
  if (cooperatorId?.value) {
    query.cooperatorId = cooperatorId?.value
  } else if (cooperatorRequired.value) {
    query.cooperatorId = '0'
  }
  const res = await $api(api, { query })
  const resData: any = res?.data?.value
  if (resData?.success) {
    return resData.data
  }
  return null
}
const cText = computed({
  get () {
    return name?.value
  },
  set (val: any) {
    emits('update:name', val)
  }
})
const information = ref([])

const handleChange = (val: any) => {
  information.value = val
}
defineExpose({ handleClear })
</script>
